import { Stack, useToast } from '@chakra-ui/react'
import { useRef } from 'react'
import useConfigList from '../../../../hooks/useConfigList'
import { Filter } from '../types'
import { useUsersQuery } from '../hooks/useUsersQuery'
import UserFilters from './UserFilters'
import UsersList from './UsersList'

interface Props {
  list?: boolean
}

export default function UsersSearchList({ list }: Props) {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const toast = useToast()

  // Fetch studies config; default to empty object to avoid undefined
  const studiesRaw = useConfigList('studies')
  const studies = studiesRaw ?? ({} as Record<string, string>)

  // Get query state and functions from custom hook
  const {
    docs,
    hasMore,
    loading,
    isTableLoading,
    search,
    reports,
    setIsTableLoading,
    useStore,
  } = useUsersQuery(list || false, studies)

  const filter = useStore((state) => state.filter)
  const input = useStore((state) => state.input)

  function handleFilterChange(newFilter: Filter) {
    setIsTableLoading(true)
    useStore.setState({
      filter: newFilter,
      docs: [],
      input: '',
    })
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  function handleInputChange(newInput: string) {
    useStore.setState({ input: newInput })
  }

  function handleLoadMore() {
    search(false)
  }

  function handleCopyEmails() {
    navigator.clipboard.writeText(docs.map((doc) => doc.data().email).join(','))
    toast({
      status: 'info',
      description: `Copied ${docs.length} email address(es) to clipboard`,
    })
  }

  return (
    <Stack spacing={4}>
      <Stack spacing={2}>
        <UserFilters
          list={list || false}
          filter={filter}
          input={input}
          studies={studies}
          onFilterChange={handleFilterChange}
          onInputChange={handleInputChange}
          inputRef={inputRef}
        />
      </Stack>
      <UsersList
        docs={docs}
        filter={filter}
        hasMore={hasMore}
        loading={loading}
        reports={reports}
        isTableLoading={isTableLoading}
        list={list}
        onLoadMore={handleLoadMore}
        onCopyEmails={handleCopyEmails}
      />
    </Stack>
  )
}
